import UnAuthorizedLayout from "../../../../branchAndBrandSpecific/layout/UnAuthorizedLayout";
import { FC, useEffect, useState } from "react";
import { AuthCard } from "../components/AuthCard";
import useCloudFunctionCall from "@/hooks/useCloudFunctionCall";
import {
  AuthenticationProps,
  AuthenticationResponse,
} from "../types/authenticationTypes";
import { createToast } from "@/utils/toaster/createToast";
import { brand } from "../../../../branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { useNavigate } from "react-router-dom";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import i18next from "i18next";
import { Flex, Text, TextField, Button, Spinner } from "@radix-ui/themes";

export const ForgotPassword: FC<{}> = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState<string>("");
  const [response, _loading, _error, authenticate] =
    useCloudFunctionCall<AuthenticationResponse>(
      "userAuthentication",
      undefined
    );
  const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const baseAuthenticationProps = {
    method: "email",
    emailAddress: email,
    platform: brand.brandValue,
    tenantId: brand.tenantId,
  } as AuthenticationProps;

  useEffect(() => {
    if (email && response) {
      if (response.status === "email-sent") {
        createToast({
          type: "success",
          message: response.payload,
        });
        localStorage.setItem("authEmailLocal", email);
        return navigate(response.redirectURL);
      }

      if (
        response.status === "not-found" ||
        response.status === "email-sent-failed"
      ) {
        createToast({
          type: "error",
          message: response.payload,
        });
        return navigate(response.redirectURL);
      }
    }
  }, [response]);

  // Page Document Title
  useDocumentTitle(i18next.t("auth.forgot.headline"));

  return (
    <UnAuthorizedLayout>
      <AuthCard
        title={i18next.t("auth.forgot.headline")}
        type="forgot-password"
      >
        <Flex direction="column" gap="4">
          <Flex direction="column" gap="1">
            <Text as="label" size="2">
              {i18next.t("auth.input.email.label")}
            </Text>
            <TextField.Root
              placeholder={i18next.t("auth.input.email.placeholder")}
              size="3"
              type="text"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  if (email && isEmailValid) {
                    await authenticate({
                      ...baseAuthenticationProps,
                      action: "forget-password",
                    });
                  }
                }
              }}
            />
          </Flex>
          <Flex justify="between">
            <Button
              variant="solid"
              disabled={_loading || !isEmailValid}
              onClick={async (e) => {
                await authenticate({
                  ...baseAuthenticationProps,
                  action: "forget-password",
                });
              }}
            >
              {_loading ? (
                <Spinner />
              ) : (
                i18next.t("auth.input.button.send_link")
              )}
            </Button>
            <Button variant="outline" onClick={() => navigate("/login")}>
              {i18next.t("auth.input.button.cancel")}
            </Button>
          </Flex>
        </Flex>
      </AuthCard>
    </UnAuthorizedLayout>
  );
};
